import ContentLoader from 'react-content-loader'

import theme from 'theme_'

export function TableLoader() {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="100"
      backgroundColor={theme.colors.newLightGrey}
      foregroundColor={theme.colors.lightGrey}
    >
      <rect x="0" y="0" rx="8" ry="8" width="100%" height="100px" />
    </ContentLoader>
  )
}
